// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"775":"4ffe006c","6734":"4ffe006c"}[chunkId] + ".chunk.css";
};